import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';
import React from 'react';
import { numberFormatter, numberFormatterCount } from '../../../utils/utilities';
import { IFundsReserve } from '../../order/order-interfaces';

export enum ReserveFundTableAccessorKeys {
	mid = 'mid',
	heldCount = 'heldCount',
	heldAmount = 'heldAmount',
	releasedCount = 'releasedCount',
	releasedAmount = 'releasedAmount',
	cancelledCount = 'cancelledCount',
	cancelledAmount = 'cancelledAmount',
	utilizedCount = 'utilizedCount',
	utilizedAmount = 'utilizedAmount',
}

export const defaultReserveFundColumnSizing: ColumnSizing = {
	[ReserveFundTableAccessorKeys.mid]: 100,
	[ReserveFundTableAccessorKeys.heldCount]: 50,
	[ReserveFundTableAccessorKeys.heldAmount]: 50,
	[ReserveFundTableAccessorKeys.releasedCount]: 50,
	[ReserveFundTableAccessorKeys.releasedAmount]: 50,
	[ReserveFundTableAccessorKeys.cancelledCount]: 50,
	[ReserveFundTableAccessorKeys.cancelledAmount]: 50,
	[ReserveFundTableAccessorKeys.utilizedCount]: 50,
	[ReserveFundTableAccessorKeys.utilizedAmount]: 50,
};

const getTableValue = (value: number, isAmount?: boolean): JSX.Element => {
	const formattedValue = isAmount ? numberFormatter(value / 100) : numberFormatterCount(value);
	return (
		<div>
			{isAmount && Boolean(value) && '$'}
			{value ? formattedValue : '-'}
		</div>
	);
};

export const defaultReserveFundColumns: MRT_ColumnDef<IFundsReserve>[] = [
	{
		accessorKey: ReserveFundTableAccessorKeys.mid,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Merchant name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<RelatedEntityNameLink id={renderedCellValue} type={RELATED_ENTITY_TYPE.MERCHANT}/>
			</ TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.heldCount,
		header: 'Held сount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Held count</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.heldAmount,
		header: 'Held amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Held amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue, true)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.releasedCount,
		header: 'Release сount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Released count</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.releasedAmount,
		header: 'Release amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Released amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue, true)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.cancelledCount,
		header: 'Cancelled сount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Cancelled count</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.cancelledAmount,
		header: 'Cancelled amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Cancelled amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue, true)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.utilizedCount,
		header: 'Utilized сount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Utilized count</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: ReserveFundTableAccessorKeys.utilizedAmount,
		header: 'Utilized amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Utilized amount</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableValue(renderedCellValue, true)}
			</TableCell>
		)
	},
];
